import React, { useState } from "react";
import { Modal, Button, Select, Spin, message, Typography, Input } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";

const { Option } = Select;
const { Title } = Typography;
const { TextArea } = Input;

const ExecuteCustomAction = ({
  visible,
  onClose,
  connectorId,
  actions,
  connections = [], // new prop for connection list
}) => {
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [queryInput, setQueryInput] = useState("");
  const [bodyInput, setBodyInput] = useState("");

  const handleExecute = async () => {
    if (!selectedAction) {
      return message.warning("Please select an action to execute");
    }
    if (!selectedConnection) {
      return message.warning("Please select a connection");
    }

    setLoading(true);
    setResult(null);

    try {
      // Parse query and body if provided
      let queryObj = {};
      let bodyObj = {};

      if (queryInput) {
        try {
          queryObj = JSON.parse(queryInput);
        } catch (err) {
          message.error("Query input is not valid JSON");
          setLoading(false);
          return;
        }
      }

      if (bodyInput) {
        try {
          bodyObj = JSON.parse(bodyInput);
        } catch (err) {
          message.error("Body input is not valid JSON");
          setLoading(false);
          return;
        }
      }

      // Build payload
      const payload = {
        input_data: {
          ...(Object.keys(queryObj).length ? { query: queryObj } : {}),
          ...(Object.keys(bodyObj).length ? { body: bodyObj } : {}),
          connection_id: selectedConnection, // include the selected connection
        },
      };

      const apiService = new ApiService(
        `${BASE_URL}/connector_actions/${selectedAction}/execute`,
        { "Content-Type": "application/json" },
        "POST",
        payload
      );
      const response = await apiService.makeCall();
      setResult(response);
      message.success("Action executed successfully");
    } catch (err) {
      console.error("Execution error:", err);
      message.error("Failed to execute action");
      setResult({ error: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Execute Custom Action"
      onCancel={onClose}
      width={700}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="execute"
          type="primary"
          onClick={handleExecute}
          loading={loading}
        >
          Execute
        </Button>,
      ]}
    >
      {/* Connection selector */}
      <div style={{ marginBottom: 16 }}>
        <Select
          style={{ width: "100%" }}
          placeholder="Select a connection"
          onChange={(value) => setSelectedConnection(value)}
          value={selectedConnection}
        >
          {connections.map((c) => (
            <Option key={c._id || c.id} value={c._id || c.id}>
              {c.name}
            </Option>
          ))}
        </Select>
      </div>

      {/* Action selector */}
      <div style={{ marginBottom: 16 }}>
        <Select
          style={{ width: "100%" }}
          placeholder="Select an action"
          onChange={(value) => setSelectedAction(value)}
          value={selectedAction}
        >
          {actions.map((a) => (
            <Option key={a._id || a.id} value={a._id || a.id}>
              {a.name} ({a.method} {a.path})
            </Option>
          ))}
        </Select>
      </div>

      {/* Query input */}
      <div style={{ marginBottom: 16 }}>
        <TextArea
          rows={4}
          placeholder="Optional: Enter query JSON"
          value={queryInput}
          onChange={(e) => setQueryInput(e.target.value)}
        />
      </div>

      {/* Body input */}
      <div style={{ marginBottom: 16 }}>
        <TextArea
          rows={4}
          placeholder="Optional: Enter body JSON"
          value={bodyInput}
          onChange={(e) => setBodyInput(e.target.value)}
        />
      </div>

      {/* Execution result */}
      {loading ? (
        <Spin />
      ) : result ? (
        <div style={{ marginTop: 20 }}>
          <Title level={5}>Execution Output</Title>
          <pre
            style={{
              background: "#f5f5f5",
              padding: 12,
              borderRadius: 6,
              maxHeight: "300px",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      ) : null}
    </Modal>
  );
};

export default ExecuteCustomAction;
